// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useReducer } from 'react'

import ReportingActions from './ReportingActions'

const defaultReportingDataTableState = {
  /* reports list */
  reports: null,
  /* pagination */
  page: 1,
  limit: 10,
  count: 0,
  /* sorting */
  sortProperty: 'startTime',
  sortDirection: 'desc',
  /* dropdown filter */
  selectedStatusDropdownOption: 'All reports',

  /* columns to be shown */
  visibleColumns: [],
  /* filter by search term */
  debouncedSearchTerm: ''
}
const defaultRecurringReportsDataTableState = {
  /* reports list */
  recurringReports: null,
  /* pagination */
  page: 1,
  limit: 10,
  total: 0,
  /* sorting */
  sortProperty: 'nextRun',
  sortDirection: 'asc',

  /* columns to be shown */
  visibleColumns: [],
  /* filter by search term */
  debouncedSearchTerm: ''
}
const defaultReportingDataTableFilterState = {
  /* filter button selections */
  time_range: 'all_time'
}
const defaultRecReportingDataTableFilterState = {}

export const initialContext = {
  reportingDataTableState: defaultReportingDataTableState,
  reportingDataTableFilterState: defaultReportingDataTableFilterState,
  recurringReportDataTableState: defaultRecurringReportsDataTableState,
  recurringReportDataTableFilterState: {},
  reportsMetaDataObj: {},
  cachedPreviewDataObj: {},
  createReportSuccessApiData: null,
  deleteReportSuccessApiData: null
}

export const ReportingReducer = (state, action) => {
  switch (action.type) {
    /* Reports datatable */
    case ReportingActions.SET_REPORTS_DATATABLE_INFO: {
      const dataTableState = action.data || {}
      return {
        ...state,
        reportingDataTableState: {
          ...state.reportingDataTableState,
          ...dataTableState
        }
      }
    }
    case ReportingActions.SET_REPORTS_DATATABLE_FILTER_INFO: {
      const dataTableFilterState = action.data || {}
      return {
        ...state,
        reportingDataTableFilterState: {
          ...defaultReportingDataTableFilterState,
          ...dataTableFilterState
        }
      }
    }
    case ReportingActions.RESET_REPORTS_DATATABLE_INFO: {
      return {
        ...state,
        reportingDataTableState: {
          ...defaultReportingDataTableState,
          visibleColumns: state.reportingDataTableState.visibleColumns
        }
      }
    }
    case ReportingActions.RESET_REPORTS_DATATABLE_FILTER_INFO: {
      return {
        ...state,
        reportingDataTableFilterState: {
          ...defaultReportingDataTableFilterState
        }
      }
    }
    /* Reports datatable */
    case ReportingActions.SET_REPORTS_METADATA: {
      const reportsMetaDataObj = action.data
      return {
        ...state,
        reportsMetaDataObj
      }
    }
    case ReportingActions.SET_CREATE_REPORTS_API_DATA: {
      const createReportSuccessApiData = action.data
      return {
        ...state,
        createReportSuccessApiData
      }
    }
    case ReportingActions.SET_DELETE_REPORTS_API_DATA: {
      const deleteReportSuccessApiData = action.data
      return {
        ...state,
        deleteReportSuccessApiData
      }
    }
    case ReportingActions.SET_REPORTS_PREVIEW_DATA: {
      const cachedPreviewDataObj = action.data
      return {
        ...state,
        cachedPreviewDataObj
      }
    }
    /* Recurring Reports datatable */
    case ReportingActions.SET_RECURRING_REPORTS_DATATABLE_INFO: {
      const dataTableState = action.data || {}
      const finalState = {
        ...state,
        recurringReportDataTableState: {
          ...state.recurringReportDataTableState,
          ...dataTableState
        }
      }
      return finalState
    }
    case ReportingActions.SET_RECURRING_REPORTS_DATATABLE_FILTER_INFO: {
      const dataTableFilterState = action.data || {}
      return {
        ...state,
        recurringReportDataTableFilterState: {
          ...dataTableFilterState
        }
      }
    }
    case ReportingActions.RESET_RECURRING_REPORTS_DATATABLE_INFO: {
      return {
        ...state,
        recurringReportDataTableState: {
          ...defaultRecurringReportsDataTableState,
          visibleColumns: state.recurringReportDataTableState.visibleColumns
        }
      }
    }
    case ReportingActions.RESET_RECURRING_REPORTS_DATATABLE_FILTER_INFO: {
      return {
        ...state,
        recurringReportDataTableFilterState: {
          ...defaultRecReportingDataTableFilterState
        }
      }
    }
    /* Recurring Reports datatable */

    default:
      return state
  }
}

const useReportingReducer = () => {
  const [ReportingState, dispatchReportingContext] = useReducer(
    ReportingReducer,
    initialContext
  )
  return { ReportingState, dispatchReportingContext }
}

export default useReportingReducer
